import { useConfig } from 'shared/config/ConfigContext';
import { Head } from 'shared/page/Head';
import { FavoriteApiProvider } from '@/context/FavoriteApiProvider';
import ResultMap from '@/scenes/resultPage/containers/resultMap/ResultMap';
import { clientConfig } from '@/server/config';
import { buildCommonProps, sanitizeCommonProps } from '@/server/data/';

const MapPage = (props) => {
    const { baseUrl } = useConfig();

    return (
        <>
            <Head
                title="Feriehjem og hytter - sammenlign pris | FINN reise"
                description="Finn tusenvis av feriehjem og hytter på et sted!"
                canonical={`${baseUrl}/reise/feriehus-hytteutleie/kart/`}
            />
            <main>
                <FavoriteApiProvider loginId={props.loginId}>
                    <ResultMap {...props} />
                </FavoriteApiProvider>
            </main>
        </>
    );
};

export const getServerSideProps = async ({ req, res, query }) => {
    const commonProps = await buildCommonProps(req, res, query);

    return {
        props: {
            config: clientConfig,
            ...sanitizeCommonProps(commonProps),
        },
    };
};
export default MapPage;
